// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"f995468f","171":"acb564d7","453":"e333520d"}[chunkId] + ".chunk.js";
};